import CourseTestAvailableContainer from './CourseTestAvailableContainer';

export default CourseTestAvailableContainer;